import { render } from "./custom-css.vue?vue&type=template&id=57deee99"
import script from "./custom-css.vue?vue&type=script&lang=js"
export * from "./custom-css.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__